import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  textWrapper: {
    display: 'block',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: theme.size.controlHeight,
    cursor: 'pointer',
  },
  disabled: {
    cursor: 'default',
    opacity: '.6',
  },
  btn: {
    minWidth: 'auto',
    padding: 2,
    borderRadius: '50%',
  },
  icon: {
    color: theme.custom.darkBlue,
    transition: '.2s linear',
  },
  openIcon: {
    transform: 'rotate(180deg)',
  },
  list: {
    maxHeight: 200,
    overflow: 'hidden',
    overflowY: 'auto',
  },
  listItem: {
    fontSize: 14,
    fontFamily: 'NeoSansStd',
  },
  gutters: {
    paddingLeft: 12,
    paddingRight: 12,
  },
  zIndex: {
    zIndex: 999,
  },
}));
